import { put } from 'redux-saga/effects';
import { Notifications } from 'types';
import { resetCounterStateAction } from 'core/widgets/Scoreboard/BallsCounter/actions';
import { resetScoreboardStateAction } from 'core/widgets/Scoreboard/Boards/actions';
import { OnShuffleData } from '../types';

export function* onShuffleSaga({ type: notificationType }: OnShuffleData) {
  if (notificationType === Notifications.SHUFFLE) {
    yield put(resetScoreboardStateAction());
    yield put(resetCounterStateAction());
  }
}
